// extracted by mini-css-extract-plugin
export default {"container":"ReferralSettingsPopup_container__IlBYQ","popup":"ReferralSettingsPopup_popup__qsu26","btnWrapper":"ReferralSettingsPopup_btnWrapper__pLtTB"};